import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router";
import logo from "../../logo.png";
import common from "../../utils/common";
import { useEffect, useState, type CSSProperties } from "react";
import { LOCALE_LABELS, LOCALES, useI18n } from "../../i18n";

const TopMenuBar = ({
  userTitle,
  isAdmin,
}: {
  userTitle?: string;
  isAdmin?: boolean;
}) => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const { locale, setLocale, t } = useI18n();
  const isCurrent = (path: string) =>
    path === "/home"
      ? pathname === "/" || pathname === "/home"
      : pathname === path || pathname.startsWith(`${path}/`);
  const activeItemStyle: CSSProperties = {
    fontWeight: 600,
    boxShadow: "inset 0 -3px 0 #d3d3d3",
  };
  const currentStyle = (path: string): CSSProperties | undefined =>
    isCurrent(path) ? activeItemStyle : undefined;
  const adminPages = [
    { path: "/users", name: t("nav.users") },
    { path: "/cron", name: t("nav.cron") },
    { path: "/trash", name: t("nav.trash") },
  ];
  const currentAdminPage = adminPages.find((page) => isCurrent(page.path));
  const adminTitle = currentAdminPage
    ? t("nav.adminWithPage", { page: currentAdminPage.name })
    : t("nav.admin");

  useEffect(() => {
    if (!userTitle || common.stringIsNullOrEmpty(userTitle)) {
      setShow(false);
      return;
    }
    setShow(true);
  }, [userTitle]);
  return (
    <>
      {show && (
        <>
          <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
              <Navbar.Brand href="/home">
                <img
                  src={logo}
                  width="22"
                  height="22"
                  className="d-inline-block align-mid mx-2"
                  alt="Calendar App"
                />
                <span>{t("nav.appTitle")}</span>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link
                    href="/home"
                    active={isCurrent("/home")}
                    style={currentStyle("/home")}
                  >
                    {t("nav.home")}
                  </Nav.Link>
                  <Nav.Link
                    href="/records"
                    active={isCurrent("/records")}
                    style={currentStyle("/records")}
                  >
                    {t("nav.records")}
                  </Nav.Link>
                  <Nav.Link
                    href="/dashboard"
                    active={isCurrent("/dashboard")}
                    style={currentStyle("/dashboard")}
                  >
                    {t("nav.dashboard")}
                  </Nav.Link>
                  {isAdmin && (
                    <NavDropdown
                      title={adminTitle}
                      id="admin-nav-dropdown"
                      className="grey-nav-dropdown"
                      active={currentAdminPage !== undefined}
                      style={
                        currentAdminPage !== undefined
                          ? activeItemStyle
                          : undefined
                      }
                    >
                      <NavDropdown.Item
                        as={Link}
                        to="/users"
                        active={isCurrent("/users")}
                      >
                        {t("nav.users")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/cron"
                        active={isCurrent("/cron")}
                      >
                        {t("nav.cron")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/trash"
                        active={isCurrent("/trash")}
                      >
                        {t("nav.trash")}
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}
                </Nav>
              </Navbar.Collapse>
              <Nav className="justify-content-end mr-5">
                <NavDropdown
                  title={t("nav.language")}
                  id="language-nav-dropdown"
                  className="grey-nav-dropdown"
                >
                  {LOCALES.map((code) => (
                    <NavDropdown.Item
                      key={code}
                      active={locale === code}
                      onClick={() => setLocale(code)}
                    >
                      {LOCALE_LABELS[code]}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown
                  title={userTitle}
                  id="basic-nav-dropdown"
                  className="grey-nav-dropdown"
                  active={isCurrent("/settings")}
                  style={currentStyle("/settings")}
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/settings"
                    active={isCurrent("/settings")}
                  >
                    {t("nav.settings")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/logout">
                    {t("nav.logout")}
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Container>
          </Navbar>
        </>
      )}
    </>
  );
};
export default TopMenuBar;
